<p class="title">
    {{buttonText | translate}}
</p>
<button
    mat-icon-button
    class="add-btn"
>
    +
</button>
